<template>
    <div>
        <input type='text' class="txt-input__field input epp-date-picker" :class="[isError ? 'is-error':'']" />
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            dateFormat: "",
            isError: false,
            maxDate: Date,
            minDate: Date,
        },
        data() {
            return {
                date: Date,
                id: Object
            };
        },
        watch: {
            maxDate: function (val) {
                if (val != undefined) {
                    this.initDatePicker();
                }
            },
            minDate: function (val) {
                if (val != undefined) {
                    this.initDatePicker();
                }
            }
        },
        created() {
        },
        mounted() {
            this.id = $(".epp-date-picker", this.$el);
            this.id.datepicker({
                autoClose: true,
                dateFormat: this.dateFormat,
                inline: false,
                view: 'months',
                minView: 'months',
                showButtonPanel: true,
               // position: 'right top',
                onSelect: this.onSelect
            });
        },

        beforeDestroy() {
            $(this.$el)
                .datepicker('hide')
                .datepicker('destroy');
        },
        methods: {
            onSelect: function (formattedDate, date, inst) {
                this.$emit('date-changed', date);
            }
            ,
            initDatePicker() {
                this.id.datepicker('destroy');

                this.id.datepicker({
                    autoClose: true,
                    dateFormat: this.dateFormat,
                    inline: false,
                    view: 'months',
                    minView: 'months',
                    showButtonPanel: true,
                  //  position: 'right top',
                    onSelect: this.onSelect,
                    maxDate: this.maxDate,
                    minDate: this.minDate
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Scripts/Components/DatePicker.vue